import React from 'react';
import { Header, flexRender } from '@tanstack/react-table';
import { baseButtonStyles } from 'components/shared/DesignSystem/shared/styles';
import styled from 'styled-components';

const SortIcon = styled.i`
  font-size: 18px;
`;
const SortIconInactive = styled.i`
  font-size: 18px;
  color: var(--cc_color_text_nonessential);
  opacity: 0.4;
  transition: all 0.2s;
`;

const SortButton = styled.button`
  ${baseButtonStyles}
  font-weight: 600;
  display: flex;
  align-items: center;
  text-align: start;
  font-size: var(--cc_size_text_s);
  color: var(--cc_color_text_subtle);
  &:focus-visible,
  &:hover {
    ${SortIconInactive} {
      opacity: 1;
    }
  }
`;

export const ColumnSortButton = <T extends object>({
  header,
}: {
  header: Header<T, unknown>;
}) => {
  const sortDirection = header.column.getIsSorted() || 'false';
  const sortIcons = {
    asc: <SortIcon aria-hidden="true" className="mdi mdi-arrow-up-thin" />,
    desc: <SortIcon aria-hidden="true" className="mdi mdi-arrow-down-thin" />,
    false: (
      <SortIconInactive aria-hidden="true" className="mdi mdi-swap-vertical" />
    ),
  };

  return (
    <SortButton type="button" onClick={header.column.getToggleSortingHandler()}>
      {header.isPlaceholder
        ? null
        : flexRender(header.column.columnDef.header, header.getContext())}
      {sortIcons[sortDirection]}
    </SortButton>
  );
};
